<template>
  <div class="tab-history-wrap section-space--mt_15">
    <div class="section-title-wrapper text-center section-space--mb_30">
      <h5 class="section-title font-width-light wow move-up">Podopédiatrie (enfants)</h5>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="tab-history-image">
          <img src="@/assets/img/pied-pro/services/podopediatrie.jpg" alt="Podopédiatrie" class="img-fluid">
        </div>
      </div>
      <div class="col-lg-8">
        <div class="tab-content-inner" style="color: #05052d">
<!--          <div class="heading mb-4"><h6>Podopédiatrie (enfants)</h6></div>-->
          Description à venir...
          <!--                  Hyperkératose, callosité et corne sont des termes synonymes utilisés pour décrire l’épaississement-->
          <!--                  de l’épiderme (couche superficielle de la peau). Elles sont souvent retrouvées à l’avant du pied ou-->
          <!--                  sous le talon et sont formées suite à une pression excessive ou à un frottement répétitif.-->
          <!--                  <br><br>-->
          <!--                  Lorsqu’elles s’accumulent de façon excessive, elles peuvent donner naissance à un cor plantaire-->
          <!--                  (ou durillon), soit une corne profonde et douloureuse au pied. Dans certains cas, le cor peut se-->
          <!--                  retrouver entre les orteils.-->
          <!--                  <br><br>-->
          <!--                  On l’appelle « œil de perdrix » et il est généralement causé par le-->
          <!--                  port de chaussures étroites ou par des déviations des orteils.-->
          <!--&lt;!&ndash;                    <div class="tab-button mb-30">&ndash;&gt;-->
          <!--&lt;!&ndash;                        <button class="ht-btn ht-btn-md">Learn more </button>&ndash;&gt;-->
          <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
        </div>
      </div>
    </div>
  </div>
</template>


<!--<template>-->
<!--    <div class="ht-tab-wrap">-->
<!--      <div class="section-title-wrapper text-center section-space&#45;&#45;mb_30">-->
<!--        <h5 class="section-title font-width-light wow move-up">Podopédiatrie (enfants) </h5>-->
<!--      </div>-->
<!--      <div class="row">-->
<!--&lt;!&ndash;        <div class="col-md-4">&ndash;&gt;-->
<!--&lt;!&ndash;          <img class="img-fluid" src="@/assets/img/pied-pro/services/podopediatrie.jpg" alt="product-details" />&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="col-md-12" style="color: #05052d">-->
<!--          <div class="float-left" style="width: 300px; margin-right: 20px;">-->
<!--            <img class="img-fluid" src="@/assets/img/pied-pro/services/podopediatrie.jpg" alt="=Podopediatrie" />-->
<!--          </div>-->
<!--&lt;!&ndash;          L’ongle incarné est un problème courant qui peut devenir très douloureux et parfois&ndash;&gt;-->
<!--&lt;!&ndash;          même incapacitant.&ndash;&gt;-->
<!--&lt;!&ndash;          <br><br>&ndash;&gt;-->
<!--&lt;!&ndash;          Il se caractérise par un ongle qui pénètre dans la peau qui&ndash;&gt;-->
<!--&lt;!&ndash;          l’entoure provoquant ainsi une inflammation, une rougeur et une enflure. Il peut&ndash;&gt;-->
<!--&lt;!&ndash;          éventuellement causer une infection avec l’apparition d’un écoulement purulent.&ndash;&gt;-->
<!--&lt;!&ndash;          <br><br>&ndash;&gt;-->
<!--&lt;!&ndash;          Touchant plus souvent l’ongle du gros orteil, il peut être causé par une mauvaise&ndash;&gt;-->
<!--&lt;!&ndash;          coupe d’ongle ou par le port de chaussures trop étroites. Il doit être pris en charge&ndash;&gt;-->
<!--&lt;!&ndash;          rapidement pour éviter toute complication.&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--</template>-->

<script>
    export default {
        name: 'Podopediatrie',
    };
</script>